import { genericCRUDService } from '../../helpers/api';

export const SERVICE_URI = '/accounts';
export const BASE_URI = '/api/v1/blacklist-reasons';

export const { findAll, findOne, create, update, remove } = genericCRUDService(
  SERVICE_URI,
  BASE_URI,
);
